























import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class TaskItem extends Vue {
    @Prop() task!: any
}
